import SystemMeter from '@components/_shared/SystemMeter';
import { ReactElement } from 'react';
import storeConnector from '@store/storeConnector';
import { SiteMeta } from '@src/types/SiteMeta';
import WeatherWidget from '@components/Sun/WeatherWidget';
import Tracker from '@src/components/_shared/Tracker/Tracker';

interface TRACKERSProps {
  siteMeta: SiteMeta;
}
function TRACKERS({ siteMeta }: TRACKERSProps): ReactElement {
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <WeatherWidget hideForecast={!siteMeta.ui.WeatherForecast_enable} />
      </div>
      <div className='fcol'>
        <Tracker />
      </div>
    </div>
  );
}

export default storeConnector(TRACKERS, {
  config: ['siteMeta'],
});
